import './modal.scss'
import MicroModal from 'micromodal';

const selectors = {
  frozen: "is-menu-open",
  burger: "[data-burger]",
};

const elements = {
  burger: document.querySelector(selectors.burger),
}

const config = {
  onShow: function(modal, element, event) {

    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    document.querySelector('body').classList.add(selectors.frozen)
  },
  awaitCloseAnimation: true,
  disableFocus: true,
  onClose: function(modal, element, event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    if (elements.burger.classList.contains('is-active')) return;
    document.querySelector('body').classList.remove(selectors.frozen)
  }
}

const initModals = () => {
  MicroModal.init(config);
}

function init() {
  initModals();
}

export default init
